import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {categoryPresetSchema} from '../utils/schemas/categoryPreset';

import {categoryPresetKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getCategoryPreset = async (id: string) => {
  const data = await api.get(`categorypresets/${id}`).json();
  return categoryPresetSchema.parse(data);
};

export const useCategoryPreset = (
  id: string,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: categoryPresetKeys.detail(id),
    queryFn: () => getCategoryPreset(id),
  });
};
export const useCategoryPresetLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getCategoryPreset;
